export default "__VITE_ASSET__6z9fRfsL__"